<template>
  <div class="audio-con">
    <audio ref="AntAudio" class="ant-audio" id="AntAudio" :src="audioSrc"></audio>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {
  },
  data(){
    return{
      AntAudio: null,
      timer: null,
      duration: 0,//音频时长
    }
  },
  computed: {
    ...mapGetters([
      'audioSrc',
    ]),
  },
  watch: {
    audioSrc(val){
      if(val){ //是否有播放地址
        window.setTimeout(()=>{
          this.audioPlay()
        },300)
      }else {
        this.audioPause()
      }
    }
  },
  created(){

  },
  methods:{
    audioPlay(){ // 播放
      this.AntAudio = this.$refs.AntAudio
      this.AntAudio.currentTime = 0 //重置播放时间点
      this.AntAudio.play()
      // this.getDuration()
      this.audioIsPlayOver()
    },
    audioPause(){ // 暂停
      this.AntAudio = this.$refs.AntAudio
      this.AntAudio.pause()
      this.$store.dispatch('audio/setAudioSrc', '')
      window.clearInterval(this.timer)
      this.timer = null
    },
    getDuration(){ // 当前音频总时长（秒）
      // this.AntAudio = this.$refs.AntAudio
      // this.$store.commit('audio/setRemainingTime', this.AntAudio.duration)
    },

    // currentTime(){ // 当前播放时间点（秒）
    //   return this.AntAudio.currentTime
    // },

    remainingTime(){ // 播放剩余时间
      let time = (this.AntAudio.duration - this.AntAudio.currentTime)
      this.$store.commit('audio/setRemainingTime', time)
    },

    audioIsPlayOver(){ //处理播放结束
      // this.AntAudio = this.$refs.AntAudio
      // this.$store.commit('audio/setRemainingTime', this.AntAudio.duration)
      this.timer = window.setInterval(()=>{
        if(this.AntAudio.ended){ //是否播放结束
          this.$store.dispatch('audio/setAudioSrc', '')
          window.clearInterval(this.timer)
          this.timer = null
        }else {
          this.remainingTime()
        }
      },250)
    }
  }
}
</script>

<style lang="less" scoped>
.audio-con{
  text-align: center;
  .ant-audio{
    display: inline-block;
    width: 0;height: 0;opacity: 0;
  }
}
</style>